import React, { useEffect } from "react";
import newLogo from "../../assets/new_logo.png";
// import amsComtel from "../../assets/ams.png";
import { DatePicker, Form, Select, message } from "antd";
import { useState } from "react";
import AxiosInstance from "../../AxiosInstance";
import { Option } from "antd/es/mentions";
import { Controller, useForm } from "react-hook-form";
import moment, { max } from "moment";
import { Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import { LDMSRequestType } from "../../constants";
const { Search } = Input;

export default function LdmsManual() {
  console.log("LdmsManual component mounted - Current URL:", window.location.pathname);
  
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    control,
    getValues,
    setValue,
  } = useForm({ mode: "onChange" });
  const [isAutoFill, setIsAutoFill] = useState(false);
  const [businessPartner, setBusinessPartner] = useState([]);
  const [productList, setProductList] = useState([]);
  const [policyData, setPolicyData] = useState({});
  const [insurerList, setInsurerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [maxId, setmaxId] = useState();
  const [relianceId, setRelianceId] = useState();
  const [bhartiId, setBhartiId] = useState(null);
  const [policySelectList, setPolicySelectList] = useState([]);
  const [bhartiEligiblityData, setBhartiEligiblityData] = useState(null);
  const [searchEnabledInsurers, setSearchEnabledInsurers] = useState([]);
  const [stageOne, setStageOne] = useState(false);
  const [branchId, setBranchId] = useState(0);
  const [isBranch, setIsBranch] = useState(false);
  const getBusinessPartner = (id) => {
    const url = `/misc/businessPartner/${id}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        let branchId = data.find(
          (row) => row.name === "Branch"
        ).businessPartnerId;
        console.log("branchId", branchId);
        setBranchId(branchId);
        setBusinessPartner(data);
      });
  };
  const getProductList = (id) => {
    const url = `/misc/product/${id}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setProductList(data);
      });
  };
  const getPolicyData = (policyNumber) => {
    if (!policyNumber) {
      message.error("Policy Number is Required");
      return;
    }
    const insurerId = getValues("insurerId");
    setLoading(true);
    const url = `/lead/getPolicyFromInsurer/${policyNumber}/${insurerId}/${true}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        console.log(data);
        if (insurerId === relianceId) {
          setPolicySelectList(data);
        } else {
          updateFormPrefillData(data);
        }
        // if (insurerId === bhartiId) {
        //   setBhartiEligiblityData(data?.additionalData);
        //   if (!data?.additionalData?.eligibilityCheck) {
        //     message.error("Eligibility data not found");
        //   }
        // }
      })
      .catch((error) => {
        message.error(error.response.data.message);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const updateFormPrefillData = (data) => {
    setPolicyData(data ?? {});
    setValue("name", data?.name);
    setValue("phoneNumber", data?.phoneNumber);
    setValue("email", data?.email);
    setValue("policyIssueDate", moment(data?.policyIssueDate));
    setValue("policyAnnualPremium", data?.policyAnnualPremium);
    setValue(
      "policySurrenderValue",
      data?.policySurrenderValue ? parseInt(data?.policySurrenderValue) : ""
    );
    setValue("planNameIc", data?.planNameIc);
    setValue("refundAmount", data?.refundAmount);
    setValue(
      "refundDate",
      data?.refundDate ? moment(data?.refundDate).format("YYYY-MM-DD") : null
    );

    const currentInsurerId = getValues("insurerId");

    switch (currentInsurerId) {
      case bhartiId:
        setValue("policyDueDate", moment(data?.premiumDueDate));
        setValue("policyPremiumPending", data?.policyPremiumPending);

        break;
      // case bhartiId:
      //   setValue(
      //     "policyDueDate",
      //     moment(
      //       data?.additionalData?.eligibilityCheck?.ReinstatementDetails
      //         ?.NewPaidTillDate,
      //       "YYYYMMDD"
      //     ).format("YYYY-MM-DD")
      //   );
      //   setValue(
      //     "policyPremiumPending",
      //     data?.additionalData?.eligibilityCheck?.ReinstatementDetails
      //       ?.GrossPayable
      //   );

      //   break;

      default:
        setValue("policyDueDate", moment(data?.policyDueDate));
        setValue("policyPremiumPending", data?.policyPremiumPending);
        break;
    }
  };
  const getInsurerList = () => {
    const url = `/misc/insurerList`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        // setProductList(data);
        setInsurerList(data);
        let maxId = data.find(
          (insurer) => insurer.name === "Axis Max Life Insurance Co. Ltd."
        ).insurerId;
        let bhartiId = data.find(
          (insurer) => insurer.name === "Bharti AXA Life Insurance Co. Ltd."
        ).insurerId;
        let relianceId = data.find(
          (insurer) =>
            insurer.name === "Reliance Nippon Life Insurance Co. Ltd."
        ).insurerId;
        let hdfcId = data.find(
          (insurer) => insurer.name === "HDFC Life Insurance Co. Ltd."
        )?.insurerId;
        setSearchEnabledInsurers([bhartiId, maxId, relianceId, hdfcId]);
        getBusinessPartner(maxId);
        // getProductList(id);

        setBhartiId(bhartiId);
        setmaxId(maxId);
        setRelianceId(relianceId);

        insurerChange(maxId);
        shouldFetchFromInsurerChange(true);
        setIsAutoFill(true);
      });
  };

  const businessPartnerChange = (businessPartnerId) => {
    errors.businessPartnerId = false;
    setValue("businessPartnerId", businessPartnerId);
    setIsBranch(businessPartnerId === branchId ? true : false);
  };
  const policySelectChange = (policyNum, option) => {
    const selectedPolicy = policySelectList.find(
      (item) => item.policyNumber === policyNum
    );
    if (selectedPolicy) updateFormPrefillData(selectedPolicy);

    errors.policy_number = false;
    setValue("policy_number", selectedPolicy?.policyNumber);
    // console.log("Selected Policy:", selectedPolicy, policySelectList);
    // console.log(policyNum, option);
  };
  const insurerChange = (insurerId) => {
    setStageOne(true);
    errors.insurerId = false;
    setValue("insurerId", insurerId);
    if (searchEnabledInsurers.includes(insurerId)) {
      shouldFetchFromInsurerChange(true);
      setIsAutoFill(true);
    } else {
      shouldFetchFromInsurerChange(false);
      setIsAutoFill(false);
    }
    updateFormPrefillData(null);
  };

  const leadTypeChange = (leadTypeId) => {
    errors.leadType = false;
    setValue("leadType", leadTypeId);
  };
  const shouldFetchFromInsurerChange = (value) => {
    // errors.shouldFetchFromInsurer = false;
    setValue("shouldFetchFromInsurer", value);
  };

  const planChange = (productId) => {
    errors.productId = false;
    setValue("productId", productId);
  };
  const issueDateChange = (_, dateString) => {
    errors.policyIssueDate = false;
    setValue("policyIssueDate", dateString);
  };

  const dueDateChange = (_, dateString) => {
    errors.policyDueDate = false;
    setValue("policyDueDate", dateString);
  };
  useEffect(() => {
    setValue("leadType", "ASSIGNMENT");
    shouldFetchFromInsurerChange(false);
    getInsurerList();
  }, []);
  const onSubmit = (value) => {
    // console.log(value);
    const payload = isAutoFill
      ? {
          countryCode: "+91",
          role: "POLICY_MASTER",
          source: "INSURER",
          referralCode: value?.referralCode,
          partnerName: value?.partnerName,
          remarks: value?.remarks,
          policyNumber: value?.policyNumber,
          planNameIc: value?.planNameIc,
          insurerId: value?.insurerId,
          businessPartnerId: value?.businessPartnerId,
          referrerId: value?.referrerId,
          employeeContactNo: value?.employeeContactNo,
          officeCode: value?.officeCode,
          shouldFetchFromInsurer: value.shouldFetchFromInsurer,
          leadDate: moment().format("YYYY-MM-DD"),
          leadType: value.leadType,
        }
      : {
          name: value?.name,
          countryCode: "+91",
          phoneNumber: value?.phoneNumber,
          role: "POLICY_MASTER",
          source: "INSURER",
          referralCode: value?.referralCode,
          partnerName: value?.partnerName,
          remarks: value?.remarks,
          email: value?.email,
          policyNumber: value?.policyNumber,
          planNameIc: value?.planNameIc,
          insurerId: value?.insurerId,
          businessPartnerId: value?.businessPartnerId,
          referrerId: value?.referrerId,
          employeeContactNo: value?.employeeContactNo,
          officeCode: value?.officeCode,
          policyAnnualPremium: value?.policyAnnualPremium,
          policySurrenderValue: value?.policySurrenderValue,
          policyPremiumPending: value?.policyPremiumPending,
          policyIssueDate: value.policyIssueDate,
          // ? value.policyIssueDate.format("YYYY-MM-DD")
          // : null,
          policyDueDate: value.policyDueDate,
          // ? value.policyDueDate.format("YYYY-MM-DD")
          // : null,
          shouldFetchFromInsurer: value?.shouldFetchFromInsurer,
          leadDate: value?.leadDate,
          leadType: value.leadType,
        };
    if (payload.insurerId === relianceId) {
      payload.phoneNumber = payload.policyNumber;
      payload.policyNumber = value.policy_number;
    }
    console.log("payload", payload);
    const url = isAutoFill ? `/lead/insurer` : "lead/insurer/manual";
    AxiosInstance()
      .post(url, payload)
      .then((resp) => {
        let { data } = resp;
        message.success("form submitted successfully");
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };
  const onChange = (e) => {
    setValue("remarks", e.target.value);
  };

  const getSelectedInsurerName = () => {
    const selectedInsurerId = getValues("insurerId");
    var name = "";
    insurerList.forEach((value) => {
      if (value.insurerId === selectedInsurerId) {
        name = value.name;
        return name;
      }
    });
    return name;
  };
  const getSelectedBusinessPartnerName = () => {
    const selectedPartnerId = getValues("businessPartnerId");
    var name = "";
    businessPartner.forEach((value) => {
      if (value.businessPartnerId === selectedPartnerId) {
        name = value.name;
        return name;
      }
    });
    return name;
  };
  return (
    <div>
      <div className="website-header d-flex justify-content-between">
        <img className="" src={newLogo} height={75} alt="logo-login" />
        <h3 className="m-3">
          <b>Lead &nbsp;Management&nbsp; System&nbsp;</b>
        </h3>
        <div className="d-flex flex-row">
          {/* <img className="" src={newLogo} height={60} alt="logo-login" /> */}
        </div>
      </div>
      <div className="mt-4 d-flex flex-column justify-content-center  align-items-center">
        {
          <>
            {" "}
            <div className="mt-0 mt-md-2 ">
              <Form
                labelAlign="left"
                labelCol={
                  {
                    // span: 5,
                  }
                }
                wrapperCol={{
                  span: 14,
                }}
                layout="horizontal"
              >
                <div className="container">
                  <div className="row gx-5">
                    <div className="col-sm-12  col-md-6">
                      <Form.Item
                        className="mb-5"
                        label={
                          <>Insurer {<span style={{ color: "red" }}>*</span>}</>
                        }
                      >
                        <div style={{ width: "210px" }}>
                          {" "}
                          <Controller
                            name="insurerId"
                            control={control}
                            errors={errors}
                            rules={{ required: true }}
                            render={(props) => (
                              <>
                                {" "}
                                {maxId !== null && (
                                  <Select
                                    {...props.field}
                                    showSearch
                                    defaultValue={props.field.value || maxId}
                                    filterOption={(input, option) => {
                                      return (option?.children ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase());
                                    }}
                                    placeholder="Select Insurer"
                                    onChange={insurerChange}
                                    className={`${
                                      errors.insurerId ? "is-invalid" : ""
                                    }`}
                                  >
                                    {insurerList.map((item) => (
                                      <Select.Option
                                        key={item.insurerId}
                                        value={item.insurerId}
                                      >
                                        {item.name}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                )}
                              </>
                            )}
                          />
                          <div className="invalid-feedback">
                            Insurer is required
                          </div>
                        </div>
                      </Form.Item>
                    </div>
                    <div className="col-sm-12  col-md-6 ">
                      <Form.Item
                        // tooltip="This is a required field"
                        className="mb-5"
                        label={
                          <>
                            Business Partner{" "}
                            {<span style={{ color: "red" }}>*</span>}
                          </>
                        }
                      >
                        <div style={{ width: "210px" }}>
                          {" "}
                          <Controller
                            name="businessPartnerId"
                            control={control}
                            errors={errors}
                            rules={{ required: true }}
                            render={(props) => (
                              <Select
                                placeholder="Select Partner"
                                onChange={businessPartnerChange}
                                className={`${
                                  errors.businessPartnerId ? "is-invalid" : ""
                                }`}
                              >
                                {businessPartner.map((item) => (
                                  <Option
                                    key={item.businessPartnerId}
                                    value={item.businessPartnerId}
                                  >
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                            )}
                          />
                          <div className="invalid-feedback">
                            Business Partner is required
                          </div>
                        </div>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </>
        }
        {stageOne && (
          <form
            className="mt-0 mt-md-1"
            id="leadForm"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Form
              labelAlign="left"
              labelCol={{
                span: 10,
              }}
              wrapperCol={{
                span: 14,
              }}
              layout="horizontal"
              //   //disabled={componentDisabled}
              // style={{
              //   minWidth: 600,
              // }}
            >
              <div className="container ">
                <div className="row gx-5">
                  <div className="col-sm-12  col-md-6 ">
                    {" "}
                    {isAutoFill ? (
                      <Form.Item
                        label={
                          relianceId === getValues("insurerId")
                            ? "Phone Number"
                            : "Policy Number"
                        }
                      >
                        <Controller
                          name="policyNumber"
                          control={control}
                          errors={errors}
                          rules={{ required: true }}
                          render={(props) => (
                            <Search
                              id="policyNumber"
                              // placeholder="Enter Policy Number"
                              onChange={(change) =>
                                setValue("policyNumber", change.target.value)
                              }
                              className={` ${
                                errors.policyNumber ? " is-invalid" : ""
                              }`}
                              // {...register("policyNumber", {
                              //   // required: true,
                              //   pattern: {
                              //     value: /^[0-9]*$/i,

                              //     message: "only numbers allowed",
                              //   },
                              // })}
                              onSearch={getPolicyData}
                              // onSearch={onSearch}
                              style={{
                                width: 200,
                                height: 30,
                              }}
                              loading={loading}
                            />
                          )}
                        />

                        <div className="invalid-feedback">
                          {errors?.policyNumber?.message}
                        </div>
                      </Form.Item>
                    ) : (
                      <Form.Item
                        label={
                          <>
                            Policy Number
                            {<span style={{ color: "red" }}>*</span>}
                          </>
                        }
                        // tooltip="This is a required field"
                      >
                        <input
                          id="policyNumber"
                          // placeholder="Enter Customer Name"
                          className={`form-control ${
                            errors.policyNumber ? " is-invalid" : ""
                          }`}
                          {...register("policyNumber", {
                            required: {
                              value: true,
                              message: "Policy Number is required",
                            },
                          })}
                        />

                        <div className="invalid-feedback">
                          {errors?.policyNumber?.message}
                        </div>
                      </Form.Item>
                    )}
                    {relianceId === getValues("insurerId") && (
                      <Form.Item
                        // tooltip="This is a required field"
                        className="mb-5"
                        label={
                          <>
                            Select Policy{" "}
                            {<span style={{ color: "red" }}>*</span>}
                          </>
                        }
                      >
                        <div>
                          {" "}
                          <Controller
                            name="policy_number"
                            control={control}
                            errors={errors}
                            rules={{ required: true }}
                            render={(props) => (
                              <Select
                                placeholder="Select Policy"
                                onChange={policySelectChange}
                                className={`${
                                  errors.businessPartnerId ? "is-invalid" : ""
                                }`}
                              >
                                {policySelectList.map((item) => (
                                  <Option
                                    key={item.policyNumber}
                                    value={item.policyNumber}
                                  >
                                    {item.policyNumber}
                                  </Option>
                                ))}
                              </Select>
                            )}
                          />
                          <div className="invalid-feedback">
                            Policy Number is required
                          </div>
                        </div>
                      </Form.Item>
                    )}
                    <Form.Item
                      label={
                        <>
                          Customer Name{<span style={{ color: "red" }}>*</span>}
                        </>
                      }
                      // tooltip="This is a required field"
                    >
                      <input
                        id="name"
                        disabled={isAutoFill}
                        // placeholder="Enter Customer Name"
                        className={`form-control ${
                          errors.name ? " is-invalid" : ""
                        }`}
                        {...register("name", {
                          required: {
                            value: true,
                            message: "name is required",
                          },
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors?.name?.message}
                      </div>
                    </Form.Item>
                    <Form.Item
                      label={
                        <>
                          Contact Number
                          {<span style={{ color: "red" }}>*</span>}
                        </>
                      }
                      // tooltip="This is a required field"
                    >
                      <input
                        id="phoneNumber"
                        // placeholder="Enter Contact Number"
                        maxLength={10}
                        disabled={isAutoFill}
                        className={`form-control ${
                          errors.phoneNumber ? " is-invalid" : ""
                        }`}
                        {...register("phoneNumber", {
                          required: {
                            value: true,
                            message: "phone number is required",
                          },
                          // pattern: {
                          //   value: /^[6789]\d{9}$/,

                          //   message: "enter valid number",
                          // },
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors?.phoneNumber?.message}
                      </div>
                    </Form.Item>
                    <Form.Item label="Issue Date">
                      <div className="input-group pb-2 position-relative">
                        {" "}
                        <Controller
                          name="policyIssueDate"
                          control={control}
                          errors={errors}
                          render={(props) => {
                            return (
                              <DatePicker
                                allowClear={false}
                                style={{ width: 210 }}
                                // defaultValue={null}
                                value={dayjs(props.field.value)}
                                disabled={isAutoFill}
                                // disabledDate={(current) => {
                                //   return (
                                //     current &&
                                //     current > moment().add(0, "month")
                                //   );
                                // }}
                                onChange={issueDateChange}
                              />
                            );
                          }}
                        />
                      </div>
                    </Form.Item>
                    <Form.Item label="Due Date" className="mb-5">
                      <Controller
                        name="policyDueDate"
                        control={control}
                        errors={errors}
                        render={(props) => (
                          <DatePicker
                            allowClear={false}
                            style={{ width: 195 }}
                            value={dayjs(props.field.value)}
                            disabled={getValues("insurerId") === maxId}
                            onChange={dueDateChange}
                          />
                        )}
                      />
                    </Form.Item>
                    <Form.Item label="Employee Name">
                      <input
                        id="partnerName"
                        // placeholder="Enter Agent Name"
                        className={`form-control ${
                          errors.partnerName ? " is-invalid" : ""
                        }`}
                        {...register("partnerName", {
                          // required: true,
                            validate: (value) => {
                          const currentInsurerId = getValues("insurerId");
                          if (currentInsurerId === 15 && (!value || value.trim() === "")) {
                          return "Employee Name is required";
                        }
                        return true;
                        },
                        })}
                        
                      />
                    </Form.Item>
                    <Form.Item label="Employee Code">
                      <input
                        id="referralCode"
                        // placeholder="Enter Agent Code"
                        className={`form-control ${
                          errors.referralCode ? " is-invalid" : ""
                        }`}
                        {...register("referralCode", {
                          // required: true,
                           validate: (value) => {
                            const currentInsurerId = getValues("insurerId");
                            if (currentInsurerId === 15 && (!value || value.trim() === "")) {
                                return "Employee Code is required";
                              }
                            return true;
                          },
                        })}
                      />
                    </Form.Item>
                    <Form.Item
                      label={
                        isBranch && bhartiId === getValues("insurerId") ? (
                          <>
                            Branch Code{<span style={{ color: "red" }}>*</span>}
                          </>
                        ) : (
                          "Office Code"
                        )
                      }
                    >
                      <input
                        id="officeCode"
                        // placeholder="Enter Agent Code"
                        className={`form-control ${
                          errors.officeCode ? " is-invalid" : ""
                        }`}
                        {...register("officeCode", {
                          required:
                            isBranch && bhartiId === getValues("insurerId"),
                        })}
                      />
                    </Form.Item>
                    <Form.Item label="Agent Contact">
                      <input
                        id="employeeContactNo"
                        // placeholder="Enter Agent Code"
                        className={`form-control ${
                          errors.employeeContactNo ? " is-invalid" : ""
                        }`}
                        {...register("employeeContactNo", {
                          // required: true,
                        })}
                      />
                    </Form.Item>
                    <Form.Item label="Refund Amount">
                      <input
                        id="refundAmount"
                        disabled
                        // placeholder="Enter Agent Code"
                        className={`form-control ${
                          errors.refundAmount ? " is-invalid" : ""
                        }`}
                        {...register("refundAmount", {
                          // required: true,
                        })}
                      />
                    </Form.Item>
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <Form.Item label="Lead Date">
                      <Controller
                        name="leadDate"
                        control={control}
                        errors={errors}
                        render={(props) => (
                          <DatePicker
                            style={{ width: 195, color: "black" }}
                            disabled={isAutoFill}
                            onChange={(value, dateString) => {
                              console.log(value, dateString);
                              setValue("leadDate", dateString);
                            }}
                            defaultValue={dayjs()}
                          />
                        )}
                      />
                    </Form.Item>

                    <Form.Item
                      className="mb-5"
                      label={
                        <>
                          Plan Name IC{<span style={{ color: "red" }}>*</span>}
                        </>
                      }
                      // tooltip="This is a required field"
                    >
                      <input
                        id="planNameIc"
                        disabled={isAutoFill}
                        // placeholder="Enter Customer Name"
                        style={{ fontSize: 10 }}
                        className={`form-control ${
                          errors.planNameIc ? " is-invalid" : ""
                        }`}
                        {...register("planNameIc", {
                          required: {
                            value: true,
                            message: "planNameIc is required",
                          },
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors?.planNameIc?.message}
                      </div>
                    </Form.Item>

                    {/* <Form.Item
            // tooltip="This is a required field"
            className="mb-5"
            label="Plan Name"
          >
            <div>
              {" "}
              <Controller
                name="productId"
                control={control}
                errors={errors}
                // rules={{ required: true }}
                render={(props) => (
                  <Select
                    placeholder="Select Plan"
                    onChange={planChange}
                    className={`${
                      errors.productId ? "is-invalid" : ""
                    }`}
                  >
                    {productList.map((item) => (
                      <Option
                        key={item.productId}
                        value={item.productId}
                      >
                        {item.productName}
                      </Option>
                    ))}
                  </Select>
                )}
              />
              <div className="invalid-feedback">Plan is required</div>
            </div>
          </Form.Item> */}
                    <Form.Item label="Annual Premium">
                      <input
                        id="policyAnnualPremium"
                        disabled={policyData?.policyAnnualPremium}
                        // placeholder="Enter Annual Premium"
                        className={`form-control ${
                          errors.policyAnnualPremium ? " is-invalid" : ""
                        }`}
                        {...register("policyAnnualPremium", {
                          // required: true,
                          // pattern: {
                          //   value: /^[0-9]*$/i,
                          //   message: "only numbers allowed",
                          // },
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors?.policyAnnualPremium?.message}
                      </div>
                    </Form.Item>
                    <Form.Item label="Fund/Surrender Value">
                      <input
                        id="policySurrenderValue"
                        // placeholder="Enter Surrender Value"
                        className={`form-control ${
                          errors.policySurrenderValue ? " is-invalid" : ""
                        }`}
                        disabled={policyData.policySurrenderValue}
                        {...register("policySurrenderValue", {
                          // required: true,
                          pattern: {
                            value: /^-?\d+(\.\d+)?$/i,

                            message: "only numbers allowed",
                          },
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors?.policySurrenderValue?.message}
                      </div>
                    </Form.Item>
                    <Form.Item
                      label={<>Customer to Pay</>}
                      // style={{ marginBottom: "105px" }}
                    >
                      <input
                        id="policyPremiumPending"
                        // placeholder="Enter Pending Premium"
                        disabled={getValues("insurerId") === maxId}
                        className={`form-control ${
                          errors.policyPremiumPending ? " is-invalid" : ""
                        }`}
                        {...register("policyPremiumPending", {
                          // required: true,
                          // pattern: {
                          //   value: /^-?\d+(\.\d+)?$/i,
                          //   message: "only numbers allowed",
                          // },
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors?.policyPremiumPending?.message}
                      </div>
                    </Form.Item>
                    <Form.Item
                      // tooltip="This is a required field"
                      className="mb-4"
                      label={
                        <>
                          Request Type {<span style={{ color: "red" }}>*</span>}
                        </>
                      }
                    >
                      <div>
                        {" "}
                        <Controller
                          name="leadType"
                          control={control}
                          errors={errors}
                          rules={{ required: true }}
                          render={(props) => (
                            <Select
                              placeholder="Select Type"
                              onChange={leadTypeChange}
                              className={`${
                                errors.leadType ? "is-invalid" : ""
                              }`}
                              defaultValue={"ASSIGNMENT"}
                            >
                              {LDMSRequestType.map((item) => (
                                <Option key={item.id} value={item.id}>
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                          )}
                        />
                        <div className="invalid-feedback">
                          Lead Type is required
                        </div>
                      </div>
                    </Form.Item>
                    <Form.Item
                      label={<>Email</>}
                      // tooltip="This is a required field"
                    >
                      <input
                        id="email"
                        disabled={isAutoFill}
                        // placeholder="Enter Customer Name"
                        className={`form-control ${
                          errors.email ? " is-invalid" : ""
                        }`}
                        {...register("email", {
                          // required: {
                          //   value: true,
                          //   message: "name is required",
                          // },
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors?.email?.message}
                      </div>
                    </Form.Item>
                    <Form.Item label="Remarks">
                      <TextArea rows={4} onChange={onChange} placeholder="" />
                    </Form.Item>
                    <Form.Item label="Refund Date">
                      <input
                        id="refundDate"
                        disabled
                        // placeholder="Enter Agent Code"
                        className={`form-control ${
                          errors.refundDate ? " is-invalid" : ""
                        }`}
                        {...register("refundDate", {
                          // required: true,
                        })}
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>
              {isAutoFill &&
                policyData &&
                (bhartiEligiblityData?.eligibilityCheck ? (
                  <></>
                ) : (
                  // <div className="container ">
                  //   <div className="row gx-5">
                  //     <div className="col-sm-12  col-md-6 ">
                  //       <Form.Item label="Gross Tax">
                  //         <input
                  //           className={`form-control `}
                  //           readOnly
                  //           value={
                  //             bhartiEligiblityData?.eligibilityCheck
                  //               ?.ReinstatementDetails?.GrossTax
                  //           }
                  //         />
                  //       </Form.Item>
                  //       <Form.Item
                  //         label={
                  //           <>
                  //             Gross Outstanding <br />
                  //             Interest
                  //           </>
                  //         }
                  //       >
                  //         <input
                  //           className={`form-control `}
                  //           readOnly
                  //           value={
                  //             bhartiEligiblityData?.eligibilityCheck
                  //               ?.ReinstatementDetails?.GrossOutstandingInterest
                  //           }
                  //         />
                  //       </Form.Item>
                  //     </div>
                  //     <div className="col-sm-12  col-md-6 ">
                  //       <Form.Item
                  //         label={
                  //           <>
                  //             Gross Outstanding <br />
                  //             Premium
                  //           </>
                  //         }
                  //       >
                  //         <input
                  //           className={`form-control `}
                  //           readOnly
                  //           value={
                  //             bhartiEligiblityData?.eligibilityCheck
                  //               ?.ReinstatementDetails?.GrossOutstandingPremium
                  //           }
                  //         />
                  //       </Form.Item>
                  //       <Form.Item label={<>Medial Test</>}>
                  //         <input
                  //           className={`form-control `}
                  //           readOnly
                  //           value={
                  //             bhartiEligiblityData?.eligibilityRequirement
                  //               ?.Requirement?.LA?.Requirement?.MedicalTest
                  //           }
                  //         />
                  //       </Form.Item>{" "}
                  //       <Form.Item label="Requirements">
                  //         <TextArea
                  //           rows={4}
                  //           readOnly
                  //           value={
                  //             bhartiEligiblityData?.eligibilityRequirement
                  //               ?.Requirement?.LA?.Requirement?.Requirements
                  //           }
                  //           placeholder=""
                  //         />
                  //       </Form.Item>
                  //     </div>
                  //   </div>
                  // </div>
                  <></>
                ))}
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="normal-button  py-1"
                  form="leadForm"
                >
                  Submit
                </button>
              </div>
              {/* </Form.Item> */}
            </Form>
          </form>
        )}
      </div>
      {/* <div style={{ position: "fixed", right: "10px", bottom: "10px" }}>
        <img alt="Call Support" style={{ height: "30px" }} src={amsComtel} />
      </div> */}
    </div>
  );
}
